export interface PluginOutputDto {
  // todo: make it string only
  id: number | string;
  config: string;
  description: string | null;
  jsFileUrl: string;
  libraryName: string;
  name: string;
  status: PluginStatus;
  version: string;
  isBackgroundPlugin: boolean;
  isSystemPlugin: boolean;
  publisherOrganization: string | undefined;
}

export enum PluginStatus {
  Unpublished = 1,
  Published,
  Hidden,
}
